import classNames from 'classnames';
import React, { ForwardedRef, RefObject } from 'react';

type Props = {
  id?: string,
  children?: React.ReactNode,
  horizontal?: boolean,
  className?: string,
  noPadding?: boolean,
  innerRef: ForwardedRef<HTMLDivElement>
};

class _PageContent extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, children, className,
      horizontal,
      noPadding
    } = this.props;

    return (
      <div id={id} ref={this.props.innerRef} className={classNames(
        (noPadding === true ? 'esko_pagecontainer-nopadding' : 'esko_pagecontainer'),
        { 'esko_verticallayout': !horizontal },
        className
      )}>
        {children}
      </div>
    );
  }
}

function PageContentRenderer (
  props: Omit<Props, 'innerRef'>,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  return <_PageContent innerRef={ref} {...props} />;
}

const PageContent = React.forwardRef(PageContentRenderer);

export default PageContent;
